import { forkJoin, from, Subscription, switchMap, take } from 'rxjs';
import { AfterViewInit, Component, ElementRef,EventEmitter, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { BaseComponent } from 'src/app/moov-common/base/base.component';
import { ChatMessage, ChatMessageRatingEnum, ChatMessageRoles, ChatMetadata, ChatSpecialString, ExternalConverdationalUseCaseData, WebSocketMessageData } from 'src/app/moov-common/services/chat/chat-data';
import { AbstractChatService } from 'src/app/moov-common/services/chat/chat.abstract.service';
import { ChatUserPromptComponent } from '../chat-user-prompt/chat-user-prompt.component';
import { ClaroEvents } from 'src/app/moov-common/services/google-analytics/analytics.enum';
import { AbstractLocalStorageService } from 'src/app/moov-common/services/localStorage/local-storage.abstract.service';
import { LocalStorageKeys } from 'src/app/moov-common/services/localStorage/local-storage.enum';
import { MatListOption, MatSelectionList } from '@angular/material/list';
import { MatSidenav } from '@angular/material/sidenav';
import { CarouselItem } from '../chat-carousel/chat-carousel.component';
import { Location } from '@angular/common';
import { ChatMessageDataType, ChatTypeEnum } from 'src/app/moov-common/services/chat/chatEnum';
import { CareerProcessTypeEnum } from 'src/app/moov-common/services/personal-user-data/personal-user-data';
import { MatDialog } from '@angular/material/dialog';
import { ChatViewDeleteConfirmationDialogComponent } from '../chat-view-delete-confirmation-dialog/chat-view-delete-confirmation-dialog.component';
import { AudioPlayer } from './audio-player';
import { FeatureID } from 'src/app/moov-common/enum/feature.enum';
import { ActivatedRoute, Router } from '@angular/router';
import { SelectUsersFromListComponent } from 'src/app/moov-common/components/select-users-from-list/select-users-from-list.component';
import { UtilsService } from 'src/app/moov-common/services/utils/utils.service';

@Component({
    selector: 'app-chat-view',
    templateUrl: './chat-view.component.html',
    styleUrl: './chat-view.component.scss',
    standalone: false
})
export class ChatViewComponent
  extends BaseComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  oldMessages: ChatMessage[] = [];
  isEmpty: boolean = true;
  imageRootFolder: string = '/assets/common/';
  liveMessage: string = '';
  presentLiveMessage: boolean = false;
  activeChatId: string = '';
  activeChatDetails: ChatMetadata | undefined;
  activeChatType : ChatTypeEnum = ChatTypeEnum.Default;
  chatTypeEnumInstance = ChatTypeEnum;
  private socketSubscription: Subscription;
  chatMessageRoles = ChatMessageRoles;
  userChats : ChatMetadata[] = [];
  presentPastChatsButton : boolean = false;
  carouselItems : CarouselItem[] = [];
  isCarouselLoading : boolean = true;
  currChatTitle = ""
  questionIdFromUrl: string = '';
  questionTextFromUrl: string = '';
  questionFromUrl_origin : number = 0;
  entryReceivedFromUrl : boolean = false;
  forceUseCases : boolean = false;
  private audioPlayer = new AudioPlayer();
  isPlaying = false;
  isRecording = false;
  isAudioProcessing = false;
  shouldAllowAudioTTS = false;
  chatAudioTTSuserEnabled = false;
  isAudioCommunicationEnabled = false;
  isAllowManagePeopleOfInterest = false;
  
  oldMessagesLoadedEvent = new EventEmitter();

  @ViewChild('userPrompt') userPrompt: ChatUserPromptComponent;
  @ViewChild("chatSideNav") chatSideNavRef: MatSidenav;
  @ViewChild('chatsSelectionList') chatSelectionListRef : MatSelectionList; 
  @ViewChild('chatMessagesContainer') private chatMessagesContainer : ElementRef;
  @ViewChild('audioElement') audioElementRef!: ElementRef<HTMLAudioElement>;

  private messageSubscription: Subscription;
  private routerParamsSubscription: Subscription;

  constructor(
    private readonly chatService: AbstractChatService,
    private readonly localStorageService: AbstractLocalStorageService,
    private route: ActivatedRoute,
    private location: Location,
    private chatAdditionalDialog: MatDialog
  ) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.isEmpty = true;

    this.analytics.sendClaroEvent(ClaroEvents.Conversational_chatOpened);
    this.getUserChats();

    this.presentPastChatsButton = this.isMobileView;
    this.veriyFeatures();
    this.subscribeToAudioPlayer();
  }

  veriyFeatures(): void{
    this.personalUserDataServiceForBaseClass.verifyFeature(FeatureID.chatAudioTTS).subscribe((isEnabled: boolean) => {
      // console.log(`isEnabled is ${isEnabled}`);
      this.shouldAllowAudioTTS = isEnabled;
      this.setAudioToChat();
    });

    this.personalUserDataServiceForBaseClass.verifyFeature(FeatureID.chatManagePeopleOfInterest).subscribe((isEnabled: boolean) => {
      // console.log(`isAllowManagePeopleOfInterest is ${isEnabled}`);
      this.isAllowManagePeopleOfInterest = isEnabled;
    });
  }

  subscribeToAudioPlayer(): void{
    this.audioPlayer.isPlaying$.subscribe((isPlaying: boolean) => {
      this.isPlaying = isPlaying;
    });
  }

  ngAfterViewInit() {
    this.subscribeToRouteParams();

  }

  getUserChats(): void{
    this.chatService.getChats().subscribe(userChats =>{
      
      if (userChats.length > 0){
        this.userChats = userChats.sort((a, b) => (a.lastUpdate < b.lastUpdate) ? 1 : ((b.lastUpdate < a.lastUpdate) ? -1 : 0));
        
        // console.log(`getUserChats userChats is ${JSON.stringify(this.userChats)}`);
        this.updateCurrentChatTitle();
        // We need to wait for the list to get updated before we select the active chat
        setTimeout(() => {
          this.setSelectedChat(this.activeChatId);
        }, 0);
      }
      else{
        // this is the firt time the user is in the chat - create a new chat
        this.startNewChat();
      }
    });
  }
       
  subscribeToRouteParams(): void {
    this.routerParamsSubscription = this.route.queryParams.subscribe(
      (params: any) => {

        let externalQuestionId = '';
        let externalQuestionText = '';
        let externalInsightId = '';
        
        if (params['questionId']){
          externalQuestionId = params['questionId'];
        }

        if (params['questionText']){
          externalQuestionText = params['questionText'];
        }

        if (params['insightId']){
          externalInsightId= params['insightId']
        }

        if (params['origin']){
          this.questionFromUrl_origin = params['origin'];
        }

        if (externalQuestionId != '' || externalQuestionText != '' || externalInsightId != '') {
          this.entryReceivedFromUrl = true;
          this.handleQuestionInUrl(externalQuestionId, externalQuestionText, externalInsightId);
        } else {
          // console.log('subscribeToRouteParams #else');
          this.startChat();
        }
      }
    );
  }

  async handleQuestionInUrl(questionId: string = '', questionText : string = '', insightId = '') {
    // console.log(`handleQuestionInUrl qID is ${questionId} qT is ${questionText} iID is ${insightId}`);
    try {
      if (questionId != ''){
        this.startNewChatWithQuestionId(questionId); 
      }
      else if (questionText != ''){
        this.startNewChatWithQuestionText(questionText); 
      }
      else if (insightId != ''){
        this.startNewChatWithInsightId(insightId);
      }
    } catch (err) {
        // console.log(`in CV handleQuestionId error is ${err}`);
    }
  }

  startNewChatWithQuestionId(questionId : string) {
    this.analytics.sendClaroEvent(ClaroEvents.Conversational_externalQuestion, {'questionId': questionId, 'origin' : this.questionFromUrl_origin});

    let chatType = ChatTypeEnum.Default;
    if (this.user?.careerProcessType == CareerProcessTypeEnum.INDEVIDUAL_CONSULTANT_LEAD){
      chatType = ChatTypeEnum.CareerIndividualConsultantLead;
    }

    forkJoin({      
      newChat : this.chatService.startNewChat(chatType),
      conversationalQuestionsDetails : this.chatService.getConversationalQuestion(questionId)
    }).subscribe(({newChat, conversationalQuestionsDetails })=>{
       this.initNewChat(newChat);

       if (conversationalQuestionsDetails.content == ''){
        return;
       }
 
        // verify that the new connection is established befor submitting the user message
        if (this.chatService.isWSConnected()) {
          // console.log('startNewChatWithQuestionId live connection already exists' );
          this.submitUserEntry(conversationalQuestionsDetails.content);
          this.questionIdFromUrl = '';
          // this.cleanUrlFromParams();
      } else {
          // Otherwise, wait for the event
          // console.log('startNewChatWithQuestionID waiting on live connection event' );
          this.chatService.liveChatConnectedEvent.pipe(take(1)).subscribe(() => {
            this.submitUserEntry(conversationalQuestionsDetails.content);
            this.questionIdFromUrl = '';
            // this.cleanUrlFromParams();
          });
        }
      });
  }

  startNewChatWithQuestionText(questionText: string): void{
    // console.log(`startNewChatWithQuestionText text is ${questionText}`);
    this.analytics.sendClaroEvent(ClaroEvents.Conversational_externalQuestion_Text, {'origin': this.questionFromUrl_origin});
    
    let chatType = ChatTypeEnum.Default;
    if (this.user?.careerProcessType == CareerProcessTypeEnum.INDEVIDUAL_CONSULTANT_LEAD){
      chatType = ChatTypeEnum.CareerIndividualConsultantLead;
    }

    this.chatService.startNewChat(chatType).subscribe((newChat)=>{
      // console.log(`startNewChatWithQuestionText service created a new Chat`);
       this.initNewChat(newChat);
       
        // verify that the new connection is established befor submitting the user message
        if (this.chatService.isWSConnected()) {
          // console.log(`startNewChatWithQuestionText chatService.isWSConnected is True`);
          this.submitUserEntry(questionText);
          // this.cleanUrlFromParams();
      } else {
          // Otherwise, wait for the event
          // console.log(`startNewChatWithQuestionText waiting on liveChatConnectedEvent`);
          this.chatService.liveChatConnectedEvent.pipe(take(1)).subscribe(() => {
            // console.log(`startNewChatWithQuestionText liveChatConnectedEvent triggered`);
            this.submitUserEntry(questionText);
            // this.cleanUrlFromParams();
          });
        }
      });
  }

  startNewChatWithInsightId(insightId : string) {
    this.analytics.sendClaroEvent(ClaroEvents.Conversational_externalInsight, {'origin' : this.questionFromUrl_origin});

    // console.log(`startNewChatWithInsightId insightId is ${insightId}`);
    this.chatService.startNewChat(ChatTypeEnum.CalendarEventPreMeeting, insightId).subscribe((newChat)=>{
       this.initNewChat(newChat);

         // verify that the new connection is established befor submitting the user message
        if (this.chatService.isWSConnected()) {
          // console.log('startNewChatWithInsightId live connection already exists' );
          this.questionIdFromUrl = '';
          // this.cleanUrlFromParams();
      } else {
          // Otherwise, wait for the event
          // console.log('startNewChatWithInsightId waiting on live connection event' );
          this.chatService.liveChatConnectedEvent.pipe(take(1)).subscribe(() => {
            this.questionIdFromUrl = '';
            // this.cleanUrlFromParams();
          });
        }
      });
  }

  cleanUrlFromParams():void{
      // Clean the URL - To replace the current URL without adding a new history entry
      // setTimeout(() =>{this.router.navigate([], {queryParams: {},replaceUrl: true });},0);
      setTimeout(() =>{
        // console.log('cleanUrlFromParams cleaning url');
        const urlWithoutQuery = this.location.path().split('?')[0];
        this.location.replaceState(urlWithoutQuery);
      },0);
  }

  startChat(): void {
    const storedAudioTTSUserEnabled = this.localStorageService.getSecured<boolean>(LocalStorageKeys.chatAudioTTSUserEnabledKey);

    if (storedAudioTTSUserEnabled != undefined){
      this.chatAudioTTSuserEnabled = storedAudioTTSUserEnabled;
    }
    else{
      this.chatAudioTTSuserEnabled = false;
    }

    // console.log('startChat');
    if (!this.activeChatId) {
      const storedLiveChatId = this.localStorageService.getSecured(LocalStorageKeys.lastActiveChatId);

      if (storedLiveChatId) {
        this.activeChatId = storedLiveChatId as string;
        this.activeChatDetails = this.userChats.find(chat => chat.id === this.activeChatId);

        this.startChatSequence();
      } else {
        // console.log('startChat no activeChatId');

        this.startNewChat();
      }
    } else {
      this.startChatSequence();
    }
  }

  openPastChats(): void {
    this.chatSideNavRef.open();
    // this.presentPastChatsButton = false;
  }

  closePastChatsSideNav(): void {
    this.chatSideNavRef.close();
    // this.presentPastChatsButton = this.isMobileView;
  }

  startChatSequence(isNewChat = false): void {
    // console.log(`startChatSequence active chat is ${this.activeChatId}`);
    const currentChat = this.userChats.find(chat => chat.id === this.activeChatId);
    if (currentChat){
      // console.log(`startChatSequence - set type to ${currentChat.type}`)
      this.activeChatType = currentChat.type;
      this.getUseCaseItems();
    }

    this.chatService.liveChat_connect(this.activeChatId);
    this.subscribeToLiveStream();
    this.setAudioToChat();

    // there are chat types, that even for new ones it still contains messages
    this.getChatOldMessages();
  }

  resetOldMessages() : void{
    // console.log(`resetOldMessages`);
    this.oldMessages = [];
    this.isEmpty = true;
  }

  getChatOldMessages(): void {
    this.chatService.getOldMessages(this.activeChatId).subscribe((messages) => {
      
      for (let currMessage of messages) {
        currMessage.content = this.utilsService.chat_formatRawMessage(currMessage.content);
      }

      if (messages.length > 0) {
        this.oldMessages = messages.sort((a, b) =>
          a.creationTimestamp > b.creationTimestamp ? 1 : b.creationTimestamp > a.creationTimestamp ? -1 : 0);

        // console.log(`getChatOldMessages oldMessages is ${JSON.stringify(this.oldMessages)}`);

        this.isEmpty = false;

      } else {
        this.oldMessages = [];
        this.isEmpty = true;
      }

      this.oldMessagesLoadedEvent.emit();
    });
  }

  chatSelectionChanged(selectedOption: MatListOption[]): void {
    // console.log('chatSelectionChanged');
    const chatId = selectedOption[0].value;
    this.changeActiveChat(chatId);
  }

  changeActiveChat(chatId : string): void{
    const currentChat = this.userChats.find(chat => chat.id === chatId);
    if (currentChat){
      this.activeChatId = chatId;
      this.activeChatDetails = currentChat;
      this.activeChatType = currentChat.type;
      this.hideUseCasesByUser();
    }
    else{
      this.activeChatDetails = undefined;
      return;
    }

    this.localStorageService.write(
      LocalStorageKeys.lastActiveChatId,
      this.activeChatId
    );

    this.endChat();
    this.startChatSequence();

    if (this.isMobileView) {
      // the selection was made from the sideNav
      this.closePastChatsSideNav();
    }
    this.updateCurrentChatTitle();
  }

  setSelectedChat(chatId: string) {
    if (this.userChats.length === 0) {
      return;
    }

    // console.log(`set selected chat for id ${chatId}`)
    let currentChat = this.userChats.find(chat => chat.id === this.activeChatId);

    if (!currentChat) {
      currentChat = this.userChats[0];
      this.changeActiveChat(currentChat.id);
    }

    if (currentChat){
      // console.log(`set selected chat - set type to ${currentChat.type}`)
      this.activeChatType = currentChat.type;
      this.activeChatDetails = currentChat;
      this.getUseCaseItems();
    }


    if (this.chatSelectionListRef) {
      const options = this.chatSelectionListRef.options.toArray();

      const optionToSelect = options.find((option) => option.value === currentChat!.id);

      if (optionToSelect) {
        this.chatSelectionListRef.selectedOptions.select(optionToSelect);
      }
    }
  }

  scrollToBottom(): void{
    if (this.chatMessagesContainer){
      try {
        this.chatMessagesContainer.nativeElement.scrollTop = this.chatMessagesContainer.nativeElement.scrollHeight;
      } catch (error) {
        console.log(error);
      }
    }
  }

  submitUserEntry(userEntry: string): void{
    // 
    // 
    // .log(`submitUserEntry userEntry is ${userEntry}`);
    if (this.isEmpty) {
      this.isEmpty = false;
    }
    
    this.sendUserMessage(userEntry);
    this.userPrompt.focusOnInput();
    setTimeout(()=> this.scrollToBottom(), 0)
  }

  presentUseCasesByUser():void{
    this.forceUseCases = true;
  }

  hideUseCasesByUser() : void{
    this.forceUseCases = false;
  }

  sendUserMessage(userText: string): void {
    // console.log(`sendUserMessage`);
    const userChatMessage = this.createUserMessage(userText);

    this.oldMessages.push(userChatMessage);

    if (this.isEmpty) {
      this.isEmpty = false;
      this.updateCurrentChatTitle();
    }

    this.liveMessage = '';
    this.presentLiveMessage = true;

    const messageData: WebSocketMessageData = {dataType: ChatMessageDataType.Text, data: userText};
    // console.log(`CV sednUserMessage userText is ${userText}`);
    this.chatService.liveChat_sendMessage(JSON.stringify(messageData));
    this.analytics.sendClaroEvent(ClaroEvents.Conversational_userMessage);
    this.analytics.sendClaroEvent(ClaroEvents.Conversational_userTextMessage);
  }

  subscribeToLiveStream(): void {
    this.socketSubscription = this.chatService.onMessage().subscribe((msg) => {
      // console.log(`subscribeToLiveStream msg is ${JSON.stringify(msg)}`);
      let message: WebSocketMessageData;
      try {
        message = JSON.parse(msg);
      } catch (error) {
        console.error('Error parsing message:', error);
        return;
      }

      if (message.dataType === 'text') {
        this.handleTextMessageDataFromServer(message.data);
      }
      else if (message.dataType === 'audio') {
        // console.log(`Received audio message ${message.data}`);
        this.handleAudioMessageDataFromServer(message.data);
      }
    });
  }

  handleTextMessageDataFromServer(msg: string): void {
    if (!msg.includes(ChatSpecialString.TERMINATION_STRING)) {
      this.liveMessage += msg;
      setTimeout(()=> this.scrollToBottom(), 0)
    }
    else{
      // message Completed
      let msgId = this.utilsService.chat_extractUUID(msg);
      if (!msgId) {
        msgId = '';
      }

      // console.log(`subscribeToLiveStream message completed msgId is ${msgId} msg was ${msg}`);

      let formattedText = this.utilsService.chat_formatRawMessage(this.liveMessage);

      const serverMessage: ChatMessage = {
        id: msgId,
        userId: this.user!.id,
        chatId: this.activeChatId,
        content: formattedText,
        role: ChatMessageRoles.SERVER,
        creationTimestamp: new Date(),
        userRating: ChatMessageRatingEnum.NATURAL,
      };

      this.oldMessages.push(serverMessage);
      // console.log(`handleTextMessageDataFromServer oldMessages is ${JSON.stringify(this.oldMessages)}`);
      this.liveMessage = '';
      this.presentLiveMessage = false;
      this.analytics.sendClaroEvent(ClaroEvents.Conversational_serverMessage);
      this.getChatOldMessages();
      this.getUserChats();
      setTimeout(()=> this.scrollToBottom(), 0);
      if (this.entryReceivedFromUrl){
        // this is the first message received after the url triggered a conversation - this is a great spot to clean it
        this.cleanUrlFromParams();
      }
    }
  }

  handleAudioMessageDataFromServer(data: string): void {
    if (this.shouldAllowAudioTTS){
      // console.log('handleAudioMessageDataFromServer');
      this.isAudioProcessing = false;
      this.audioPlayer.feedChunk(data);
    }
  }

  messageLiked(msgId: string): void {
    this.chatService
      .setMessageRating(msgId, ChatMessageRatingEnum.LIKED)
      .subscribe();
    this.changeMessageRating(msgId, ChatMessageRatingEnum.LIKED);
    this.analytics.sendClaroEvent(ClaroEvents.Conversational_messageLiked);
  }

  messageDisliked(msgId: string): void {
    this.chatService
      .setMessageRating(msgId, ChatMessageRatingEnum.DISLIKED)
      .subscribe();
    this.changeMessageRating(msgId, ChatMessageRatingEnum.DISLIKED);
    this.analytics.sendClaroEvent(ClaroEvents.Conversational_messageDisliked);
  }

  changeMessageRating(
    messageId: string,
    userRating: ChatMessageRatingEnum
  ): void {
    let messageToChange = this.oldMessages.find((msg) => msg.id === messageId);

    if (messageToChange) {
      messageToChange.userRating = userRating;
    }
  }

  createUserMessage(userText: string): ChatMessage {
    const userMessage: ChatMessage = {
      id: '',
      userId: this.user!.id,
      chatId: this.activeChatId,
      content: userText,
      role: ChatMessageRoles.USER,
      creationTimestamp: new Date(),
      userRating: ChatMessageRatingEnum.NATURAL,
    };

    return userMessage;
  }

  startNewChat(): void {
    // console.log('startNewChat');
    this.oldMessages = [];
    this.isEmpty = true;
    this.updateCurrentChatTitle();

    let chatType = ChatTypeEnum.Default;
    if (this.user?.careerProcessType == CareerProcessTypeEnum.INDEVIDUAL_CONSULTANT_LEAD){
      chatType = ChatTypeEnum.CareerIndividualConsultantLead;
    }

    this.chatService.startNewChat(chatType).subscribe((newChat) => {
      this.initNewChat(newChat);
    });
  }

  startNewChatFromPastChatsSideNav(): void{
    // console.log('startNewChatFromPastChatsSideNav');
    this.startNewChat();
    this.chatSideNavRef.toggle();
  }

  initNewChat(newChat: ChatMetadata): void {
    // console.log(`initNewChat ${newChat.id}, chatType: ${newChat.type}`);
    this.localStorageService.write(
      LocalStorageKeys.lastActiveChatId,
      newChat.id
    );
    this.endChat();
    this.resetOldMessages();
    this.activeChatId = newChat.id;
    this.activeChatType = newChat.type;
    this.activeChatDetails = newChat;
    this.getUseCaseItems();
    this.startChatSequence(true);
    this.getUserChats();
    this.analytics.sendClaroEvent(ClaroEvents.Conversational_newChatStarted);
  }

  endChat(): void {
    // console.log(`endChat`);
    if (this.messageSubscription) this.messageSubscription.unsubscribe();
    if (this.socketSubscription) this.socketSubscription.unsubscribe();
    this.chatService.liveChat_closeConnection();
  }

  ngOnDestroy() {
    this.endChat();
    if (this.routerParamsSubscription)
      this.routerParamsSubscription.unsubscribe();
  }

  updateCurrentChatTitle(): void {
    const currentChat = this.userChats.find(chat => chat.id === this.activeChatId);
    this.currChatTitle = currentChat?.title || "";
  }

  handleCarouselSelectedQuestion(question: string) {
    if (this.isCarouselLoading || !question) return
    this.forceUseCases = false;
    this.submitUserEntry(question);
  }

  getUseCaseItems() {
    this.isCarouselLoading = true;

    // console.log(`getUseCaseItems for ${this.activeChatId} and type ${this.activeChatType}`);
    this.chatService.getUseCasesToChat(this.activeChatType).subscribe(useCases => {
      
      this.carouselItems = useCases.map(item => ({
                id: item.subjectId,
                topic: item.subjectName,
                questions: item.useCaseQuestions.map(question => question.content)}));

      this.isCarouselLoading = false;
    });
  }

  deleteChat(chatId: string): void {
      const dialogRef = this.chatAdditionalDialog.open(ChatViewDeleteConfirmationDialogComponent, {
                                                    data:{},
                                                    height: 'fit-content',
                                                    width: (this.isMobileView? '90%':'30%'),                                                   
                                                    direction: this.isRTL ? 'rtl' : 'ltr'});
  
      const currentChat = this.userChats.find(chat => chat.id === this.activeChatId);

      if (!currentChat) {
        return;
      }

      // Pass the chat name as an input
      dialogRef.componentInstance.chatName = currentChat.title;
  
      // Subscribe to the outputs
      dialogRef.componentInstance.confirm.subscribe(() => {
        // Perform the deletion logic here
        // console.log('Deletion selected');
        dialogRef.close();
        this.chatService.deleteChat(chatId).subscribe(() => {
            this.analytics.sendClaroEvent(ClaroEvents.Conversational_chatDeleted);
            this.getUserChats();
        });    
      });
  
      dialogRef.componentInstance.cancel.subscribe(() => {
        // Handle cancellation if needed
        // console.log('Deletion canceled');
        dialogRef.close();
      });
  } 

  handleAudioToggle(isAudioOn: boolean): void{
    this.chatAudioTTSuserEnabled = isAudioOn;
    this.localStorageService.write(LocalStorageKeys.chatAudioTTSUserEnabledKey, isAudioOn);

    if (!isAudioOn){
      this.audioPlayer.stop();
    }

    this.setAudioToChat();
  }

  setAudioToChat(): void{
    // console.log('setAudioToChat');
    if (this.chatAudioTTSuserEnabled && this.shouldAllowAudioTTS){
      this.chatService.registerChatForAudio(this.activeChatId).subscribe();
      this.isAudioCommunicationEnabled = true;
    }
    else{
      this.chatService.unregisterChatForAudio(this.activeChatId).subscribe();
      this.isAudioCommunicationEnabled = false;
    }

    this.isRecording = false;
    this.isPlaying = false;
    this.isAudioProcessing = false;
  }

  stopPlayback(): void{
    this.isPlaying = false;
    this.audioPlayer.stop();
  }

  handleRecordingStarted(): void {
    console.log('handleRecordingStarted isRecording was', this.isRecording);
    this.isRecording = true;
    this.isAudioProcessing = false;
    console.log('handleRecordingStarted isRecording is', this.isRecording);

    if (this.isRecording){
      this.stopPlayback();
    }
  }

    handleUserRecordingCompleted(audioBlob: Blob): void {
    console.log('AUDIODBG', new Date().toISOString(), 'handleUserRecordingCompleted');
    this.isRecording = false;
    this.isAudioProcessing = true;    
    // Create a new worker instance
    console.log('handleUserRecordingCompleted creating worker url', new URL('./blob-to-base64.worker', import.meta.url));
    const worker = new Worker(new URL('./blob-to-base64.worker', import.meta.url), { type: 'module' });
    
    // Listen for messages from the worker
    worker.onmessage = ({ data }) => {
      if (data.error) {
        console.error('Worker error:', data.error);
      } else {
        const base64String: string = data.base64;
        const messageData: WebSocketMessageData = {
          dataType: ChatMessageDataType.Audio,
          data: base64String
        };
        this.chatService.liveChat_sendMessage(JSON.stringify(messageData));
        this.analytics.sendClaroEvent(ClaroEvents.Conversational_userMessage);
        this.analytics.sendClaroEvent(ClaroEvents.Conversational_userVoiceMessage);
      }
      // Terminate the worker when done
      worker.terminate();
    };

    // Send the blob to the worker for conversion
    worker.postMessage(audioBlob);    
  }

  managePeopleOfInterest(): void{
    const dialogRef = this.chatAdditionalDialog.open(SelectUsersFromListComponent, {
      data:{},
      height: 'fit-content',
      width: (this.isMobileView? '90%':'20%'),                                                   
      direction: this.isRTL ? 'rtl' : 'ltr'});

    if (this.activeChatDetails){
      // console.log('managePeopleOfInterest currentChat', JSON.stringify(this.activeChatDetails));
      dialogRef.componentInstance.selectedUsersIds = new Set(this.activeChatDetails.poiList);
    }
    // Pass the chat name as an input
    // dialogRef.componentInstance.possibleUsers = [{id: '1', firstName: 'John', lastName: 'Doe'},{id: '2', firstName: 'Jane', lastName: 'Doa'},{id: '3', firstName: 'Jim', lastName: 'Beam'}];

    dialogRef.afterClosed().subscribe(() => {
      const selectedUsersIds = [...dialogRef.componentInstance.selectedUsersIds];

      // first update the UI
      if (this.activeChatDetails){
        this.activeChatDetails.poiList = selectedUsersIds;
      }

      // then update the backend
      this.chatService.registerPeopleOfInterest (this.activeChatId, selectedUsersIds).subscribe(() => {});
    });

// Subscribe to the outputs
dialogRef.componentInstance.close.subscribe(() => {
  const selectedUsers = dialogRef.componentInstance.selectedUsers;
  // console.log('SelectUsersFromListComponent closed selected users ', JSON.stringify(selectedUsers));
  });
  }
}
